"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Badge_1 = __importDefault(require("components/shared/Badge"));
const CardLabel_1 = __importDefault(require("components/shared/CardLabel/CardLabel"));
const TooltipContainer_1 = __importDefault(require("components/shared/Tooltips/TooltipContainer"));
const GroupingCardLabel = ({ label, isSquad = false }) => {
    const { useBadge, iconLabel, useMaxWidth } = label;
    const tooltipContent = useBadge ? label.content : label.title;
    let tooltipText;
    if (iconLabel == 'history') {
        tooltipText = `Last updated: ${tooltipContent}`;
    }
    else if (iconLabel == 'leader' || iconLabel == 'member') {
        tooltipText = `You are ${tooltipContent.replace('As', '')} of this ${isSquad ? 'squad' : 'tribe'}`;
    }
    else if (iconLabel == 'team' || iconLabel == 'project') {
        tooltipText = `This tribe has ${tooltipContent}`;
    }
    return (react_1.default.createElement(TooltipContainer_1.default, { show: true, position: "top", text: tooltipText, useMaxWidth: false }, useBadge ? (react_1.default.createElement(Badge_1.default, Object.assign({}, label, { truncate: true, customMaxWidth: "max-w-[92px]" }))) : (react_1.default.createElement(CardLabel_1.default, Object.assign({}, label, { truncate: true, withSpace: false, maxWidthClass: useMaxWidth ? useMaxWidth : 'max-w-[100px]' })))));
};
exports.default = GroupingCardLabel;
